import { render, staticRenderFns } from "./tasks-badge-status.vue?vue&type=template&id=3e87d6ea&"
import script from "./tasks-badge-status.vue?vue&type=script&lang=js&"
export * from "./tasks-badge-status.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports